const moment = require('moment');
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import store from 'store2';
import config from './config';
import { reportSubscriptionPurchase } from './common/events';
import Icon from './common/icons/Icon';
import Loading from './common/components/Loading';
import SubscribeForm from './SubscribeForm';
import { createAndSubscribeUser, resetPromoCode, validatePromoCode } from './redux/actions';
import { formatValidationErrors, formatSubscriptionErrors } from './common/utils/getApiReducer';
import normalPlans from './common/plans';
import coachingPlans from './common/coaching-plans';

let plans = { ...normalPlans, ...coachingPlans };

class Subscribe extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    let plan = Object.keys(plans).find(key => !!plans[key].default);
    let giftCodeToValidate = {};
    const queryString = this.props.location.search.split('?')[1];
    const autofill = {
      name: '',
      email_address: '',
      email_confirm: '',
      postal_code: '',
      mileage_plus_number: '',
    };

    if (queryString) {
      const parsedQuery = queryString
        .split('&')
        .map(str => str.split('='))
        .reduce((prev, curr) => {
          prev[curr[0]] = curr[1];
          return prev;
        }, {});

      if (props.location.pathname === '/' && (parsedQuery.giftCode || parsedQuery.code)) {
        giftCodeToValidate = {
          code: parsedQuery.giftCode || parsedQuery.code,
          loaded: false,
        };
      }
      if (parsedQuery.plan && Object.keys(plans).includes(parsedQuery.plan.toLowerCase())) {
        plan = parsedQuery.plan.toLowerCase();
      }

      if (parsedQuery.partner) {
        const name = parsedQuery.firstname + ' ' + parsedQuery.lastname;
        const emailAddress = parsedQuery.emailaddress;
        const postalCode = parsedQuery.billingpostalcode;
        const UID = parsedQuery.UID;
        autofill.name = name;
        autofill.postal_code = postalCode;
        autofill.email = emailAddress;
        autofill.email_confirm = emailAddress;
        autofill.mileage_plus_number = UID;
      }
      autofill.promoCode = giftCodeToValidate.code;
    }

    this.state = {
      plan,
      subscribed: false,
      giftCodeToValidate,
      autofill,
    };
  }

  componentDidMount() {
    const token = store.get(config.auth.idTokenKey);

    if (token) {
      this.props.history.push('/subscription');
    }

    if (this.state.giftCodeToValidate.code) {
      this.validateCode(this.state.giftCodeToValidate.code).then(() => {
        this.setState(state => ({
          giftCodeToValidate: {
            code: state.giftCodeToValidate.code,
            loaded: true,
          },
        }));
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { promoCode } = this.props;

    if (!promoCode.get('loaded') && nextProps.promoCode.get('loaded')) {
      window.scrollTo(0, 0);
    }
  }

  validateCode = code => {
    return this.props.dispatch(validatePromoCode(code));
  };

  handleRemovePromoCode = () => {
    this.props.dispatch(resetPromoCode());
  };

  handlePlanChanged = plan => {
    this.setState({ plan });
  };

  handleSubmit = values => {
    const { promoCode, match: { path } } = this.props;

    return new Promise((resolve, reject) => {
      window.Stripe.card.createToken(
        {
          name: values.name.trim(),
          number: values.number.replace(/[^\d]/g, ''),
          cvc: values.cvc,
          exp_month: values.exp_month,
          exp_year: values.exp_year,
          address_zip: values.postal_code,
        },
        (status, response) => {
          if (response.error) {
            reject(new SubmissionError({ [response.error.param || '_error']: response.error.message }));
          } else {
            resolve(response.id);
          }
        }
      );
    })
      .then(paymentSource => {
        const payload = {
          name: values.name,
          email: values.email,
          plan: plans[this.state.plan].stripeId,
          source: paymentSource,
          phone: values.phone,
        };

        if (path === '/mileageplus') {
          payload.UID = values.mileage_plus_number;
        }
        if (promoCode.get('loaded') && promoCode.getIn(['data', 'valid'])) {
          payload.coupon = promoCode.getIn(['data', 'id']);
        } else if (values.promoCode) {
          // Attempt to use whatever the user has typed into the promoCode field
          payload.coupon = values.promoCode;
        }

        if (path === '/trial') {
          payload.trial = true;
        }

        return this.props.dispatch(createAndSubscribeUser(payload));
      })
      .then(action => {
        if (!action.response.ok) {
          /**
           * In the case of card decline errors, there is no validation error attached to the error object.
           * In that case, we will have to dispatch the error manually.
           *
           * This assumes that the only type of error to be thrown without any validation attached is 'card declined' errors.
           * If other error types arise, this code will have to be expanded upon.
           */
          if (action.json.validationErrors) {
            throw new SubmissionError(formatValidationErrors(action.json).toJS());
          } else {
            throw new SubmissionError(formatSubscriptionErrors(action.json).toJS());
          }
        } else {
          let value = action.json.plan.amount;

          if (action.json.discount) {
            const coupon = action.json.discount.coupon;
            if (coupon.valid) {
              value = Math.max(value - (coupon.amount_off ? coupon.amount_off : coupon.percent_off / 100 * value), 0);
            }
          }

          reportSubscriptionPurchase(
            `${(value / 100).toFixed(2)}`,
            action.json.status,
            `${path === '/trial' ? 'Trial' : 'Subscription'} ${this.state.plan}`
          );

          if (values.mileage_plus_number) {
            const customerId = action.json.customer;
            window.location.href = `https://www.mileageplusgolf.com/index.php/process/?miles=y&mpgpartner=tathatagolf&UID=${values.mileage_plus_number}&total-amount=199.99&partnerreferencenumber=${customerId}&transactiondate=${moment().format(
              'MMDDYYYY'
            )}`;
          }

          this.setState({ subscribed: true });
        }
      });
  };

  renderCTA = () => {
    const { match: { path } } = this.props;

    if (path === '/trial') {
      return (
        <div className="subscribe__cta">
          <h3>Start Your Free 7-Day Trial Today!</h3>
          <p>
            Enjoy free unlimited access to Tathata Golf Training Courses (including the{' '}
            <em>All-New 60-Day Training Program</em>), Tathata TV, and Video Library for 7 days. Without spending a
            dollar, learn the movements of the greatest golfers & athletes in history. Discover how students across the
            globe are getting better within 7 days of Tathata Training.
          </p>
        </div>
      );
    }

    return (
      <div className="subscribe__cta">
        <h3>Become a Tathata Golf Member Today!</h3>
        <p>
          With your membership you will have unlimited access to Tathata Golf Training Courses (including the{' '}
          <em>All-New 60-Day Training Program</em>), Tathata TV, Video Library, and other member benefits.
        </p>
      </div>
    );
  };

  render() {
    const { promoCode, match: { path } } = this.props;
    const { giftCodeToValidate, subscribed, plan } = this.state;
    const onTrialRoute = path === '/trial';
    const onPromoPage = path === '/mileageplus';

    if (giftCodeToValidate.code && !giftCodeToValidate.loaded) {
      return <Loading />;
    }

    if (subscribed) {
      return (
        <div className="subscribe__wrapper">
          <div className="subscribe__centered">
            <h3>Go check your email</h3>
            <p>Congratulations, you subscribed! Check your email to finish signup.</p>
          </div>
        </div>
      );
    }

    return (
      <div className="subscribe__wrapper subscribe__with-background">
        <div className="container subscribe">
          <div className="subscribe__details subscribe__details-min-height">
            {this.renderCTA()}
            <div className="bullets__wrapper">
              <ul className="left_bullets">
                <li>
                  <Icon icon="CheckmarkCircleOutline" />Unlimited streaming of all video content
                </li>
                <li>
                  <Icon icon="CheckmarkCircleOutline" />Download videos for offline viewing
                </li>
                <li>
                  <Icon icon="CheckmarkCircleOutline" />
                  {onTrialRoute ? (
                    'Risk-free access to membership & benefits'
                  ) : (
                    'Access to Certified Movement Specialists'
                  )}
                </li>
                <li>
                  <Icon icon="CheckmarkCircleOutline" />New Courses & TV Shows added regularly
                </li>
              </ul>
            </div>
          </div>
          <SubscribeForm
            initialValues={this.state.autofill}
            onPromoPage={onPromoPage}
            onSubmit={this.handleSubmit}
            onSubmitPromoCode={this.validateCode}
            onRemovePromoCode={this.handleRemovePromoCode}
            onChangePlan={this.handlePlanChanged}
            promoCode={promoCode}
            trial={onTrialRoute}
            plan={plan}
            history={this.props.history}
          />
        </div>
        {!onPromoPage ? (
          <a className="legacy-site" target="_blank" rel="noopener noreferrer" href="https://legacy.tathatagolf.com">
            Use the Legacy Website
          </a>
        ) : null}
      </div>
    );
  }
}

export default connect(state => {
  return {
    promoCode: state.promoCode,
  };
})(Subscribe);



// WEBPACK FOOTER //
// ./src/Subscribe.js